import css from 'styled-jsx/css'

import { colors, sizes } from '../../../theme'


export default css`
  :global(section.brands) {
    padding: 0;
  }

  .wrapper-brands {
    margin: 10rem 0;
  }

  .wrapper-brands :global(.text) {
    color: ${colors.pureWhite};
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .wrapper-brands {
      margin: 5rem 0;
    }
  }
`
